import React, { ReactElement } from "react";
import { Chapter } from "../../components/Chapter";
import { HuidigeSituatieHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Paragraph } from "../../components/Paragraph";
import { PersonaliaTable } from "./personalia-table";
import { InkomensTable } from "./inkomens-table";
import { PensioenTable } from "./pensioen-table";
import { WoonsituatieTable } from "./woonsituatie-table";
import { AovTable } from "./producten/aov-table";
import { OrvTable } from "./producten/orv-table";
import { LevensverzekeringTable } from "./producten/levensverzekering-table";
import { KredietenTable } from "./producten/kredieten-table";
import { LijfrentesTable } from "./producten/lijfrentes-table";
import { VermogenTable } from "./producten/vermogen-table";
import { OverigeFinancielePostenTable } from "./producten/overige-financiele-posten-table";
import { HypothekenTable } from "./producten/hypotheken-table";

type HuidigeSituatieProps = {
  hoofdstuk: HuidigeSituatieHoofdstuk;
};

export const HuidigeSituatieChapter = ({
  hoofdstuk,
}: HuidigeSituatieProps): ReactElement => {
  return (
    <Chapter>
      {hoofdstuk.titel && <Heading text={`${hoofdstuk.titel}`} level={1} />}
      <Paragraph paragraaf={hoofdstuk?.paragrafen?.["p41201"]} />
      {hoofdstuk.personalia && hoofdstuk.personalia.length > 0 && (
        <PersonaliaTable data={hoofdstuk.personalia} />
      )}
      {hoofdstuk.inkomens && <InkomensTable data={hoofdstuk.inkomens} />}
      {hoofdstuk.pensioenen && hoofdstuk.pensioenen.length > 0 && (
        <PensioenTable data={hoofdstuk.pensioenen} />
      )}
      {hoofdstuk.woonsituaties && hoofdstuk.woonsituaties.length > 0 && (
        <WoonsituatieTable data={hoofdstuk.woonsituaties} />
      )}
      {hoofdstuk.hypotheken && hoofdstuk.hypotheken.length > 0 && (
        <HypothekenTable data={hoofdstuk.hypotheken} />
      )}
      {hoofdstuk.aov && hoofdstuk.aov.length > 0 && (
        <AovTable data={hoofdstuk.aov} />
      )}
      {hoofdstuk.levensverzekeringen &&
        hoofdstuk.levensverzekeringen.length > 0 && (
          <LevensverzekeringTable data={hoofdstuk.levensverzekeringen} />
        )}
      {hoofdstuk.overlijdensrisicoverzekeringen &&
        hoofdstuk.overlijdensrisicoverzekeringen.length > 0 && (
          <OrvTable data={hoofdstuk.overlijdensrisicoverzekeringen} />
        )}
      {hoofdstuk.kredieten && hoofdstuk.kredieten.length > 0 && (
        <KredietenTable data={hoofdstuk.kredieten} />
      )}
      {hoofdstuk.uitkerendeLijfrentes &&
        hoofdstuk.uitkerendeLijfrentes.length > 0 && (
          <LijfrentesTable data={hoofdstuk.uitkerendeLijfrentes} />
        )}
      {hoofdstuk.vermogens && hoofdstuk.vermogens.length > 0 && (
        <VermogenTable data={hoofdstuk.vermogens} />
      )}
      {hoofdstuk.overigeFinancieelPosten &&
        hoofdstuk.overigeFinancieelPosten.length > 0 && (
          <OverigeFinancielePostenTable
            data={hoofdstuk.overigeFinancieelPosten}
          />
        )}
    </Chapter>
  );
};
